export enum ButtonSize {
  BROWSE = 'browse',
  BOX = 'box',
  CARD = 'card',
  CTA = 'cta',
  CTA_LONG = 'cta-long',
  LARGE = 'large',
  MD = 'md',
  SMALL = 'small'
}

export enum ButtonColor {
  BLUE = 'blue',
  DEFAULT = 'default',
  GREEN = 'green',
  ORANGE = 'orange',
  WHITE = 'white'
}

export enum ButtonVariant {
  FILLED = 'filled',
  OUTLINED = 'outlined',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  QUATERNARY = 'quaternary',
  SIDEBAR = 'sidebar'
}

export enum ButtonAlignment {
  START = 'justify-start',
  CENTER = 'justify-center',
  END = 'justify-end'
}

export enum DataType {
  STRING = 'string',
  NUMBER = 'number',
  DATE = 'date',
  ACTION = 'action'
}

export enum Alignment {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center'
}

export enum SelectFieldSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small'
}

export enum TextFieldSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small'
}
